import React from 'react';
import { Modal, Table, Descriptions, Form, Input, Typography, Divider, Button } from 'antd';
import { isEmpty } from 'ramda';
import { useModel } from '../../../components/use';
import { message } from '../../../components/biz';
import { network, generators, asserts } from '../../../utils';
import api from '../../../config/api';

import './index.less';

const { Text, Paragraph } = Typography;

const initialState = {
  list: [],
  selectedRowKeys: [],
};

const updateState = (state, payload) => ({ ...state, ...payload });

const fetchAddressList = async ({ dispatch }) => {
  const response = await network.get(api.activeArea.luckyDraw.addrList);
  if (response.success) {
    const result = generators.generatorObject(response.data);
    if (!result.success) {
      message.error(result.message);
      return;
    }
    dispatch('updateState')({ list: generators.generatorArray(result.data) });
  }
};

const updateAddressList = async ({ payload }) => {
  const response = await network.put(api.activeArea.luckyDraw.addrUpdate, payload);
  return response.success;
};

export default Form.create()(
  React.forwardRef(
    ({ form, onConfirm, addrInfo, handleAddrCancel, addrVisible, okLoading }, ref) => {
      const { getFieldDecorator, setFieldsValue, validateFields } = form;

      const { state, loading, dispatch } = useModel({
        state: initialState,
        reducers: { updateState },
        effects: { fetchAddressList, updateAddressList },
      });

      React.useEffect(() => {
        if (!isEmpty(addrInfo)) setFieldsValue(addrInfo);
        dispatch('fetchAddressList')();
      }, [addrInfo, addrVisible]); // eslint-disable-line

      const handleConfirm = () => {
        validateFields((err, values) => {
          if (err) {
            message.info('请填写相关地址信息！');
            return;
          }
          dispatch('updateAddressList')({ ...values, addrId: addrInfo.addrId }).then((success) => {
            handleAddrCancel();
            asserts.isFunction(onConfirm) && onConfirm(values);
          });
        });
      };

      return (
        <>
          <Modal
            title={
              <>
                <span>请确认实物奖品接收地址</span>
                <Divider type="vertical" />
                <Text type="warning">
                  <small>
                    可选择表格中任一条数据作为收货地址，或新增地址，新增地址不会作为正常货物收货地址
                  </small>
                </Text>
              </>
            }
            width={1000}
            visible={addrVisible}
            onCancel={handleAddrCancel}
            // onOk={handleConfirm}
            // okType="btn-info"
            footer={[
              <Button type="btn-info" onClick={handleConfirm} loading={okLoading}>
                确定
              </Button>,
            ]}
          >
            <Descriptions className="address-form" size="small" column={2}>
              <Descriptions.Item label="收货人姓名">
                {getFieldDecorator('receiver', {
                  rules: [
                    {
                      required: true,
                      message: '请填写收货人姓名',
                    },
                  ],
                })(<Input className="x-fill-100" />)}
              </Descriptions.Item>
              <Descriptions.Item label="手机号">
                {getFieldDecorator('phone', {
                  rules: [
                    {
                      required: true,
                      message: '请填写手机号',
                    },
                  ],
                })(<Input className="x-fill-100" />)}
              </Descriptions.Item>
              <Descriptions.Item label="收货地址" span={2}>
                {getFieldDecorator('address', {
                  rules: [
                    {
                      required: true,
                      message: '请填写收货地址',
                    },
                  ],
                })(<Input className="x-fill-100" />)}
              </Descriptions.Item>
            </Descriptions>
            <Table
              loading={!!loading['fetchAddressList']}
              pagination={false}
              scroll={{ y: 350 }}
              dataSource={state.list}
              rowKey={(_, index) => `${index}`}
              rowSelection={{
                type: 'radio',
                onChange: (selectedRowKeys, selectedRows) => {
                  // eslint-disable-next-line
                  const { shrxm: receiver, xxdz: address, sj: phone } = selectedRows[0];
                  setFieldsValue({ receiver, address, phone });
                },
              }}
              bordered
              size="small"
            >
              <Table.Column title="收货人姓名" dataIndex="shrxm" width={200} />
              <Table.Column
                title="收货地址"
                dataIndex="xxdz"
                render={(value) => (
                  <Paragraph style={{ marginBottom: 0 }} ellipsis>
                    {value}
                  </Paragraph>
                )}
              />
              <Table.Column title="手机号" dataIndex="sj" width={140} />
            </Table>
          </Modal>
        </>
      );
    },
  ),
);
